import { combineReducers } from "redux"
import { routerReducer } from "react-router-redux"
import autoMergeLevel1 from "redux-persist/lib/stateReconciler/autoMergeLevel1"
import { persistReducer } from "redux-persist"
// import storage from "../utils/storage-manager"
import storage from "redux-persist/lib/storage" // defaults to localStorage for web and AsyncStorage for react-native
import { reducer as form } from "redux-form"
import { reducer as ui } from "./ui.redux"
import { reducer as rates } from "../containers/rates/rates.redux"

const FORM_PERSIST_CONFIG = {
  key: "form",
  stateReconciler: autoMergeLevel1,
  storage: storage,
  blacklist: ["ratesQueryForm"]
}

export default combineReducers({
  router: routerReducer,
  ui,
  form: persistReducer(FORM_PERSIST_CONFIG, form),
  rates
})



// WEBPACK FOOTER //
// ./src/redux/index.js